<app-breadcrumb *ngIf="!disableBreadcrumb" [master]="'Kadry'" [parentName]="'Wnioski urlopowe'" [name]="'Lista'"></app-breadcrumb>
<div class="leave-application-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="leave-application-list-filters">

    <mat-form-field class="leave-application-list-filter" >
      <mat-label>Pracownik</mat-label>
      <input matInput placeholder="Jan Kowalski" name="employee" [(ngModel)]="initialFilters.employee">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'leave_application_type'"
      [label]="'Rodzaj wniosku'" class="leave-application-list-filter"
      [(ngModel)]="initialFilters.type" name="type"
    ></app-dict>
    <app-dict
      [multiple]="false" [dictType]="'leave_application_status'"
      [label]="'Status'" class="leave-application-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <app-datepicker
      class="leave-application-list-filter"
      label="Data złożenia wniosku od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="leave-application-list-filter"
      label="Data złożenia wniosku do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="leave-application-list-filter"
      label="Termin urlopu od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.startAt" name="startAt"
    ></app-datepicker>

    <app-datepicker
      class="leave-application-list-filter"
      label="Termin urlopu do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.endAt" name="endAt"
    ></app-datepicker>

<!--    <mat-form-field class="leave-application-list-filter" >-->
<!--      <mat-label>Wymiar urlopu</mat-label>-->
<!--      <input matInput placeholder="Wymiar urlopu" name="day" [(ngModel)]="initialFilters.day"   type="number"-->
<!--             min="0"-->
<!--             step="1" >-->
<!--    </mat-form-field>-->

    <mat-form-field appearance="standard" class="leave-application-list-filter">
      <mat-label> Wymiar urlopu</mat-label>
      <mat-select [(ngModel)]="initialFilters.leaveType" name="leaveType">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="'full'">Pełny dzień</mat-option>
        <mat-option [value]="'half'">1/2 dnia</mat-option>
        <mat-option [value]="'hour'">Godzina</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="leave-application-list-filter" >
      <mat-label>Rok</mat-label>
      <input matInput placeholder="Rok" name="year" [(ngModel)]="initialFilters.year"   type="number"
             step="1" >
    </mat-form-field>
  </form>

  <div class="leave-application-list-buttons">
    <div class="pull-right">
      <button *ngIf="(userPermissions | async).human_resources.admin_root" (click)="downloadReport()" [disabled]="!(userPermissions | async).human_resources.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource">


    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data złożenia wniosku </th>
      <td mat-cell *matCellDef="let element">
         {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Rodzaj wniosku</th>
      <td mat-cell *matCellDef="let element">
        {{element.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>


    <ng-container matColumnDef="start">
      <th mat-header-cell *matHeaderCellDef> Termin urlopu  </th>
      <td mat-cell *matCellDef="let element">
        {{element.startDate | date:'y-MM-dd'}}/{{element.endDate | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="day">
      <th mat-header-cell *matHeaderCellDef> Liczba dni urlopu   </th>
      <td mat-cell *matCellDef="let element">
        {{element.time?  '-' : element.day }}
      </td>
    </ng-container>

    <ng-container matColumnDef="employyee">
      <th mat-header-cell *matHeaderCellDef>Pracownik   </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/kadry/wnioski-urlopowe/szczegoly', element.uuid]">{{element.leaveOfAbsence.employee.user.firstName}} {{element.leaveOfAbsence.employee.user.lastName}}</a>
      </td>
    </ng-container>



    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <!--        <button (click)="openDocument(element)"-->
        <!--                mat-icon-button color="primary"><mat-icon>visibility</mat-icon></button>-->
        <!--        <button mat-icon-button color="accent" aria-label="" (click)="downloadFile(element.uuid)">-->
        <!--          <mat-icon>download</mat-icon>-->
        <!--        </button>-->
        <button [disabled]="!(userPermissions | async).human_resources.admin_root"  mat-icon-button color="accent" (click)="downloadPdf(element)">  <mat-icon>download</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
